const LOGO_ASPECT = 1748 / 807;

type MakerMarketplaceLogoProps = {
  /** Rendered height in CSS pixels. */
  height?: number;
  className?: string;
};

/**
 * Inline brand mark so SVG wordmark text uses the same Instrument Sans as the app
 * (via --font-instrument-sans on &lt;html&gt;/&lt;body&gt;).
 */
export function MakerMarketplaceLogo({ height = 48, className }: MakerMarketplaceLogoProps) {
  const width = Math.round(height * LOGO_ASPECT);

  return (
    <svg
      viewBox="0 0 1748 807"
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Maker Marketplace"
      className={className}
      style={{ display: 'block', flexShrink: 0 }}
    >
      <g transform="translate(-420.89 -583.17)">
        <clipPath id="mm-logo-clip">
          <rect x="420.89" y="583.17" width="1747.836" height="806.162" />
        </clipPath>
        <g clipPath="url(#mm-logo-clip)">
          <g transform="matrix(0.86501,0,0,0.759238,57.705637,237.622123)">
            <path
              d="M2441.487,544.499L2441.487,1428.004C2441.487,1477.207 2406.425,1517.154 2363.238,1517.154L499.138,1517.154C455.952,1517.154 420.89,1477.207 420.89,1428.004L420.89,544.499C420.89,495.296 455.952,455.349 499.138,455.349L2363.238,455.349C2406.425,455.349 2441.487,495.296 2441.487,544.499ZM2417.402,544.499C2417.402,510.441 2393.132,482.789 2363.238,482.789L499.138,482.789C469.244,482.789 444.974,510.441 444.974,544.499L444.974,1428.004C444.974,1462.063 469.244,1489.714 499.138,1489.714L2363.238,1489.714C2393.132,1489.714 2417.402,1462.063 2417.402,1428.004L2417.402,544.499Z"
              fill="#2b2f7f"
            />
          </g>
          <g transform="matrix(1,0,0,1,119.419565,271.772617)">
            <text
              x="360.431"
              y="622.983"
              fill="#2b2f7f"
              fontSize="266.667"
              fontFamily="var(--font-instrument-sans), 'Instrument Sans', sans-serif"
            >
              m
              <tspan x="605.498 747.631 882.298" y="622.983 622.983 622.983">
                ake
              </tspan>
              r
            </text>
            <text
              x="360.431"
              y="998.316"
              fill="#2b2f7f"
              fontSize="266.667"
              fontFamily="var(--font-instrument-sans), 'Instrument Sans', sans-serif"
            >
              m
              <tspan x="605.498" y="998.316">
                a
              </tspan>
              rk
              <tspan x="982.298 1131.098" y="998.316 998.316">
                et
              </tspan>
              plac
              <tspan x="1740.965" y="998.316">
                e
              </tspan>
            </text>
          </g>
          <g transform="matrix(1.023562,0,0,1,-48.511336,26.158358)">
            <rect
              x="1346.565"
              y="669.115"
              width="750.068"
              height="226.813"
              fill="none"
              stroke="#2b2f7f"
              strokeWidth="8.24"
            />
          </g>
          {[
            [0.89, 0.17],
            [64.97, 0.17],
            [129.06, 0.17],
            [193.14, 0.17],
            [257.23, 0.17],
            [321.31, 0.17],
            [385.4, 0.17],
            [449.48, 0.17],
            [513.56, 0.17],
            [577.65, 0.17],
            [641.73, 0.17],
            [705.82, 0.17],
          ].map(([tx, ty]) => (
            <g key={`${tx}-${ty}`} transform={`translate(${tx} ${ty})`}>
              <path
                d="M1392.976,695.103C1392.976,695.103 1376.204,845.942 1328.891,921.916"
                fill="none"
                stroke="#2b2f7f"
                strokeWidth="8.33"
              />
            </g>
          ))}
        </g>
      </g>
    </svg>
  );
}
